<form id="payment-form" class="_load-animate _load-active">

  <div mat-dialog-title class="_pay-dialog-title">
    <span class="_cap">{{'EX_PAYMENT_MODAL' | translate}}</span>
    <button mat-icon-button mat-dialog-close cdkFocusInitial>
      <mat-icon aria-label="Close Dialog">close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content>
    <div class="stripe-container">
      <div id="payment-element"></div>
      @if (requiereAVS) {
        <div id="stripe-address-element" style="margin-top:16px;"></div>
      }
    </div>
  </div>

  <div mat-dialog-actions style="flex-direction:column; justify-content:center;margin-bottom:0">
    <div id="stripe-payment-message" class="hidden text-danger" style="color: #df1b41;"></div>
    <button mat-raised-button color="accent" class="lg rounded btn-block" id="stripe-submit" disabled>
      <div class="d-flex justify-content-between align-items-center">
        <span>{{'Submit' | translate}}</span>
        <span>{{data.total | lcurrency}}</span>
        <mat-icon class="_next">{{appService.nextIcon}}</mat-icon>
      </div>
    </button>
    <div class="text-center"><img src="/assets/images/vendors/poered-by-stripe-2.png" style="margin-top: 25px; max-width: 200px; width: 200px; opacity: 0.8" /></div>
  </div>
</form>
